import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/lib/services/common.service';

@Component({
    selector: 'app-store-listing',
    templateUrl: './store-listing.component.html',
    styleUrls: ['./store-listing.component.scss'],
    standalone: false
})
export class StoreListingComponent implements OnInit {

  @Input() item: any;
  @Output() favEvent = new EventEmitter();

  constructor(
    private router: Router,
    private commonService: CommonService,
  ) { }

  ngOnInit() { }

  favouriteShop(shop_id: any, isFavourite: any, shop: any) {
    this.favEvent.emit({ shop_id: shop_id, isFavourite: isFavourite, shop: shop })
  }

  /**
   * @name gotoStore
   * @type Function - Navigate to store all products listing
   * **/
  gotoStore(details: any) {
    this.router.navigate([`/b2b-productlisting/${details.shop_id}`], {
      queryParams: { vendorDetails: JSON.stringify(details) },
    });
  }

  async openWithInWebBrowser(url: any) {
    if (!url || !url.latitude || !url.longitude) {
      return this.commonService.errorToast(`Failed to get shop address. Please try again later.`);
    }
    const { latitude, longitude } = url;
    const latlon = latitude + ',' + longitude;
    const mapUrl = `https://maps.google.com/?q=${latlon}`;

    return window.open(mapUrl, "_blank");
  }

  direction(event: Event) {
    event.stopPropagation();
  }
}
